module.exports = __webpack_public_path__ + "img/up.b949a515.svg";